import axiosInstance from 'services/base/axiosInstance';
import { RequestOptionsInterface } from 'model/services/requestOption';
import webStorageClient from 'utils/webStorageClient';
import { message } from 'antd';
import i18n from 'services/i18n';

const patchRequest = (
  url: string,
  options?: RequestOptionsInterface,
  formDataType?: string
): Promise<object> => {
  const data = options?.data;
  const tokenClient = webStorageClient.getToken();
  const enableFlashMessageSuccess = options?.enableFlashMessageSuccess || false;
  const enableFlashMessageError = options?.enableFlashMessageError || true;
  const messageSuccessCustom = options?.messageSuccessCustom || 'success';

  return axiosInstance
    .patch(url, data, {
      headers: {
        Authorization: `Bearer ${tokenClient}`,
        'Content-Type': formDataType ? formDataType : 'application/json'
      }
    })
    .then((res: any) => {
      if (enableFlashMessageSuccess) {
        if (res?.message) {
          message.success(i18n?.t(`message:${res?.message}`));
        } else {
          message.success(i18n?.t(`message:${messageSuccessCustom}`));
        }
      }
      return res;
    })
    .catch(err => {
      if (enableFlashMessageError && err?.response?.data?.errors?.length > 0) {
        err?.response?.data?.errors?.forEach((mess: string) => {
          message.error(i18n?.t(`message:${mess}`));
        });
      }
      return Promise.reject(err);
    });
};

export { patchRequest };
